/*global angular*/
var ageRange = angular.module('ageRange', []);
ageRange.directive('ageRange', ['ageRangeManager', function (ageRangeManager) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./ageRange.html'),
    replace: false,
    transclude: true,
    scope: {
      developmentStep: '=',
      color: '='
    },
    link: function (scope, element, attrs) {
      scope.ageRangeText = ageRangeManager.ageRangeToString(scope.developmentStep.startage, scope.developmentStep.endage);
      scope.isEmptyRange = scope.ageRangeText === '';
    }
  };
}]);
module.exports = ageRange;




// WEBPACK FOOTER //
// ./web/js/module/ageRange/ageRange.js